<div class="container dropdown-page">
  <h1>Access Denied</h1>

  <p>We're sorry, but your current level of membership doesn't include access to this resource.</p>
  <p>Click <a href="https://www.ascpskincare.com/join">here</a> to join ASCP for full access. 
    If you have questions, please contact us at <a href="tel:800-789-0411">800-789-0411</a>, or <a href="mailto:getconnected@ascpskincare.com">getconnected@ascpskincare.com</a>.</p>
</div>